var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9991 0C10.1694 0 9.4991 0.670312 9.4991 1.5V2.4C6.07723 3.09375 3.4991 6.12187 3.4991 9.75V10.6313C3.4991 12.8344 2.68817 14.9625 1.22567 16.6125L0.87879 17.0016C0.48504 17.4422 0.39129 18.075 0.630353 18.6141C0.869415 19.1531 1.40848 19.5 1.9991 19.5H19.9991C20.5897 19.5 21.1241 19.1531 21.3679 18.6141C21.6116 18.075 21.5132 17.4422 21.1194 17.0016L20.7725 16.6125C19.31 14.9625 18.4991 12.8391 18.4991 10.6313V9.75C18.4991 6.12187 15.921 3.09375 12.4991 2.4V1.5C12.4991 0.670312 11.8288 0 10.9991 0ZM13.1225 23.1234C13.685 22.5609 13.9991 21.7969 13.9991 21H10.9991H7.9991C7.9991 21.7969 8.31316 22.5609 8.87566 23.1234C9.43816 23.6859 10.2022 24 10.9991 24C11.796 24 12.56 23.6859 13.1225 23.1234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDesktop);
export default __webpack_public_path__ + "static/media/notification_desktop.ad6806f38278a8d48291776ae3b378b2.svg";
export { ForwardRef as ReactComponent };